import { Classes, Dialog } from "@blueprintjs/core";
import * as React from "react";
import styled from "styled-components";
import {
  LieuFormationAgrementApi,
  LieuFormationAgrementDecisionMultipleDto,
  LieuFormationAgrementDecisionMultipleDtoFromJSON
} from "../../../../../../api";
import { useApiService, useCrudApi, useTl } from "../../../../../../hooks";
import * as Yup from "yup";
import { ETLCodes } from "../../../../../../locales";
import { SmallFormGenerator } from "../../../../../../components";
import { FieldGroup } from "nsitools-react";
import { LieuFormationAgrementDecision } from "..";
import { endOfToday } from "date-fns";

const StyledDialog = styled(Dialog)`
  width: 700px;
  height: auto;
  background-color: white;
`;

export interface ILieuFormationAgrementDecisionDialogProps {
  idslieuFormationAgrement: number[];
  dialogOpen: boolean;
  onClose: (refresh: boolean) => void;
}

export const LieuFormationAgrementDecisionDialog: React.FunctionComponent<ILieuFormationAgrementDecisionDialogProps> = ({
  idslieuFormationAgrement = [],
  dialogOpen,
  onClose
}) => {
  const { t } = useTl();
  const api = useApiService(LieuFormationAgrementApi);

  const { data, loading, saveItem, saving, validationErrors } = useCrudApi(
    React.useMemo(
      () => ({
        getApiFn: () => {
          return LieuFormationAgrementDecisionMultipleDtoFromJSON({
            idslieuFormationAgrement: idslieuFormationAgrement
          });
        },
        saveApiFn: async (d: LieuFormationAgrementDecisionMultipleDto) => {
          return api.lieuFormationAgrementDecisionMultiple({ LieuFormationAgrementDecisionMultipleDto: d });
        },
        onSaved: () => onClose(true)
      }),
      [api, idslieuFormationAgrement, onClose]
    )
  );

  const FormSchema = React.useMemo(
    () =>
      Yup.object().shape({
        idlieuFormationAgrementDecision: Yup.number()
          .nullable()
          .required(t(ETLCodes.Required)),
        dateDecision: Yup.date()
          .nullable()
          .max(endOfToday(), t(ETLCodes.DateCannotBeInFurture))
          .required(t(ETLCodes.Required))
      }),
    [t]
  );
  return (
    <StyledDialog title={t(ETLCodes.Decision)} isOpen={dialogOpen} onClose={() => onClose(false)}>
      <div className={Classes.DIALOG_BODY}>
        <SmallFormGenerator
          initialValues={data}
          onSubmit={saveItem}
          editMode={true}
          validationSchema={FormSchema}
          onCancel={() => onClose(false)}
          showDeleteButton={false}
          saving={saving}
          loading={loading}
          validationErrors={validationErrors}
        >
          <FieldGroup>
            <LieuFormationAgrementDecision multiple idstade={0} />
          </FieldGroup>
        </SmallFormGenerator>
      </div>
    </StyledDialog>
  );
};
